import { ChangeDetectionStrategy, Component, HostBinding, Input, OnInit } from "@angular/core";
import { MenuItem } from "primeng/api";
import { IEpisode } from "@project/models/episodes/episode";
import { IEpisode_Diagnosis } from "../models/episodes/episode_diagnosis";
import { EpisodeService } from "./episode.service";
import { EpisodeStatus } from "@project/models/episodes/episode-status";

@Component({
    selector: "duplicate-episode-ribbon",
    templateUrl: "./duplicate-episode-ribbon.component.html",
    styleUrls: ["./duplicate-episode-ribbon.component.scss"],

})
export class DuplicateEpisodeRibbonComponent  {
    private _episode: IEpisode;
    diagnosis?: IEpisode_Diagnosis[];
    createdDateInfo: string;
    createdUserTitle:string;
    createdFullName: string;
    createdUserRole: string;

    updatedDateInfo: string;
    modifiedUserTitle:string;
    modifiedUserFullName:string;
    modifiedUserRole:string;



    @Input() get episode() {
        return this._episode;
    }

    set episode(episode: IEpisode) {
        this._episode = episode;
        this.setEpisodeInfo(episode);
    }

    @Input() showViewButton:boolean=true;
    @Input() showHover:boolean=true;


    constructor(public  episodeService: EpisodeService) {}

    private clearEpisodeInfo() {
        this.diagnosis = null;
        this.createdDateInfo = null;
        this.createdUserTitle = null;
        this.createdFullName = null;
        this.createdUserRole = null;

        this.updatedDateInfo = null;
        this.modifiedUserTitle = null;
        this.modifiedUserFullName = null;
        this.modifiedUserRole = null;

    }


    private setEpisodeInfo(episode?: IEpisode) {
        this.clearEpisodeInfo();

        if (!episode) {
            return;
        }

        this.diagnosis = episode.diagnoses;

        this.createdDateInfo = `Created: ${this.episodeService.formatDate(episode.createDateTime)}`;
        this.updatedDateInfo = `Last updated: ${this.episodeService.formatDate(episode.updateDateTime)} `;
        this.createdFullName=this.episode.userFullName.replace(/^([a-z])([^\s]*\s*)([a-z])(.*)$/i, "$1$3").toUpperCase();
        this.createdUserTitle=this.episodeService.getTitle(this.episode.userTitle);
        this.episodeService.getRole(this.episode.userRole);

    }

}
